
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APP_VERSION } from "@/config/version";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-golf-50 border-t border-golf-200 py-4 px-6 mt-auto">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-golf-600">
            {t("footer.version")} {APP_VERSION}
          </p>
          
          <div className="flex flex-wrap gap-4 text-sm">
            <Link 
              to="/privacy" 
              className="text-golf-600 hover:text-golf-800 transition-colors"
            >
              {t("footer.privacyPolicy")}
            </Link>
            <Link 
              to="/legal" 
              className="text-golf-600 hover:text-golf-800 transition-colors"
            >
              {t("footer.legalNotice")}
            </Link>
            <Link 
              to="/gdpr" 
              className="text-golf-600 hover:text-golf-800 transition-colors"
            >
              {t("footer.dataManagement")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
